// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container__1_b7q","breadcrumbs":"Index_breadcrumbs__2XIZs","content":"Index_content__2vPDW"};